import { Reveal } from '../ui/Reveal';
import styles from './CommitGraph.module.css';

const COLS = 32;
const ROWS = 7;
const CELL = 12;
const GAP = 3;

// Deterministic activity levels (0–4), denser mid-week and toward recent weeks
const levels = Array.from({ length: COLS * ROWS }, (_, i) => {
  const col = Math.floor(i / ROWS);
  const row = i % ROWS;
  const noise = Math.abs(Math.sin(i * 12.9898) * 43758.5453) % 1;
  const weekday = row > 0 && row < 6 ? 0.18 : -0.2;
  return Math.max(0, Math.min(4, Math.floor((noise + weekday + col / COLS / 2) * 4.2) - 1));
});

/** A contribution grid that fills in column by column, like a year of open-source work. */
export function CommitGraph() {
  return (
    <Reveal className={styles.graph} aria-hidden="true">
      <svg viewBox={`0 0 ${COLS * (CELL + GAP)} ${ROWS * (CELL + GAP)}`} focusable="false">
        {levels.map((level, i) => (
          <rect
            key={i}
            x={Math.floor(i / ROWS) * (CELL + GAP)}
            y={(i % ROWS) * (CELL + GAP)}
            width={CELL}
            height={CELL}
            rx="2"
            className={styles.cell}
            data-level={level}
            style={{ '--d': `${Math.floor(i / ROWS) * 45 + (i % ROWS) * 20}ms` }}
          />
        ))}
      </svg>
    </Reveal>
  );
}
